export const fillzero = n => n < 10 ? '0' + n : '' + n;


// WEBPACK FOOTER //
// ./src/js/filters/fillzero.js